export var BannerNotificationListType;
(function (BannerNotificationListType) {
    BannerNotificationListType["BY_AGENT"] = "by_agent";
    BannerNotificationListType["BY_LIST"] = "by_list";
    BannerNotificationListType["BY_USER_TYPE"] = "by_user_type";
    BannerNotificationListType["BY_AGENT_TYPE"] = "by_agent_type";
})(BannerNotificationListType || (BannerNotificationListType = {}));
//# sourceMappingURL=BannerNotificationListType.js.map